import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
var api__aribSendOtp = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(order_uuid) {
    var _res$response;
    var params, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          params = {
            order_uuid: order_uuid
          };
          _context.n = 1;
          return fetcher(null, true).post('/aarib/send-otp', params);
        case 1:
          res = _context.v;
          if (!(res !== null && res !== void 0 && (_res$response = res.response) !== null && _res$response !== void 0 && _res$response.data)) {
            _context.n = 2;
            break;
          }
          return _context.a(2, res.response.data);
        case 2:
          if (!res) {
            _context.n = 3;
            break;
          }
          return _context.a(2, res);
        case 3:
          return _context.a(2, null);
      }
    }, _callee);
  }));
  return function api__aribSendOtp(_x) {
    return _ref.apply(this, arguments);
  };
}();
export default api__aribSendOtp;